/** @jsx jsx */
import { css } from "@emotion/react";
import videoShape from '../images/LP-versar/stars.png'
import videoShapeMobile from '../images/LP-versar/stars.png'
import EducacaoInfantil from '../images/LP-arabe/jornada/educacao-infantil.svg'
import EducacaoInfantilH from '../images/LP-arabe/jornada/educacao-infantil-hover.svg'
import EducacaoInfantilA from '../images/LP-arabe/jornada/educacao-infantil-active.svg'
import EnsinoFundamental from '../images/LP-arabe/jornada/ensino-fundamental.svg'
import EnsinoFundamentalH from '../images/LP-arabe/jornada/ensino-fundamental-hover.svg'
import EnsinoFundamentalA from '../images/LP-arabe/jornada/ensino-fundamental-active.svg'

export const jornadaCompletaStyle = css`
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 108px 0;
  /* background-image: url(${videoShape});
  background-repeat: no-repeat; */
  background-size: cover;
  overflow: clip;
  scroll-margin-top: 70px;

  @media only screen and (max-width: 600px) {
    padding: 60px 0; 
  }

  @media (max-width: 850px) {
    background-image: none;
  }

  .title-sec {
    margin-bottom: 56px;
    h2 {
    color: #3C3C3C;
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
    width: 100%;
    max-width: 526px;
    span {
      color: #F26F33;
      font-weight: 600;
    }
  }

  p {
    color: #686868;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    margin-bottom: 0px;
  }
  }
  
  video {
    max-width: 1100px;
    @media (max-width: 850px) {
        max-width: 343px;
      margin-bottom: 100px;
    }
  }

  .video-institutional {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .title-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    h2 {
      color: #375F92;
      text-align: center;
      font-size: 40px;
      font-weight: 700;
      line-height: 100%;
      letter-spacing: -0.8px;
      margin-bottom: 24px;
    }
    p {
      
      color: #666;
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 150%;
      max-width: 920px;

      @media (max-width: 850px) {
        max-width: 335px;
      }
    }
  }

  .text-container {
    display: flex;
    justify-content: center;
    padding-block: 52px;
    
    @media (max-width: 850px) {
    background-image: url(${videoShapeMobile});
    background-repeat: no-repeat;
    background-size: cover;
    
      p {

        max-width: 343px !important;
      }
    }

    p {
      color:#375F92;
      font-size: 40px;
      font-weight: 700;
      line-height: 120%;
      letter-spacing: -0.8px;
      max-width: 862px;
      .full-text {
        color: #8A588D;
        .socioemocional {
          color: #8A588D;
          font-size: 40px;
          font-weight: 800 !important;
          line-height: 120%;
          letter-spacing: -0.8px;
        }
      }
    }
  }

  .educacao-infantil {
    width: 100%;
    max-width: 550px;
    aspect-ratio: 550 / 346;
    background: url(${EducacaoInfantil}) center/cover no-repeat;
    display: block;
    cursor: pointer;
    transition: background-image 0.2s ease; 
    -webkit-tap-highlight-color: transparent;
    margin-bottom: 32px;
  }

  .educacao-infantil:hover {
    background-image: url(${EducacaoInfantilH});
    transform: none;
    border: none;
    outline: none;
    transform: scale(1) !important;
  }

  .educacao-infantil:active {
    background-image: url(${EducacaoInfantilA});
    transform: scale(1);
  }

  .ensino-fundamental {
    width: 100%;
    max-width: 550px;
    aspect-ratio: 550 / 346;
    background: url(${EnsinoFundamental}) center/cover no-repeat;
    display: block;
    cursor: pointer;
    transition: background-image 0.2s ease; 
    -webkit-tap-highlight-color: transparent;
  }

  .ensino-fundamental:hover {
    background-image: url(${EnsinoFundamentalH});
    transform: none;
    border: none;
    outline: none;
    transform: scale(1) !important;
  }

  .ensino-fundamental:active {
    background-image: url(${EnsinoFundamentalA});
    transform: scale(1);
  }

  @media (hover: none) and (pointer: coarse) {
    .educacao-infantil:hover {
      background-image: url(${EducacaoInfantil}); 
    }
    .ensino-fundamental:hover {
      background-image: url(${EnsinoFundamental});
    }
  }
`
